import React from 'react'
import styled from 'styled-components';
import { FiArrowRight } from 'react-icons/fi';

const FlexWrapper = styled.div`
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center; 
  gap : 66px;          
  align-items: center;
//   padding: 0 1rem;

  p {
    margin: 0;
    font-size: 0.95rem;
    color: #111827;
  }

 .btntran{
  color : #71717A;
  display: flex;
  align-items: center;
 border: 1px solid #AEAEAE1A;
  padding: 0.4rem ;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
margin : 10px;
  svg {
    font-size: 1rem;
    color: #111827;
  }
}

`;
function ButtonTransaction({ onClick }) {

  return (
    <div>
         <FlexWrapper>
            <p>Vue d’ensemble du compte</p>
            <button className='btntran' onClick={onClick}>Voir les transactions <FiArrowRight style={{ marginLeft: '8px' }}/></button>
        </FlexWrapper>
    </div>
  )
}

export default ButtonTransaction